import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { Uchain } from '../redux/api/agent';
import { sagaActions } from './sagaActions';
import {
    updateSproCarrierList,
    updateSproCarrierOperationObj,
    updateSproCarrierIsLoading,
    updateSproCarrierTotalElements,
} from '../redux/reducers/reducerSlices/SproCarrierManagementReducer';

function* fetchSproCarrierListSaga(data) {
    const tempStatusObj = { ...data.operationObj };
    try {
        yield put(updateSproCarrierIsLoading(true));
        const response = yield call(Uchain.sproCarrierManagement, data.payload);
        const list = Array.isArray(response) ? response : (response?.data ?? []);
        const total =
            list[0]?.TotalCount !== undefined
                ? list[0].TotalCount
                : response?.totalElements !== undefined
                ? response.totalElements
                : list.length;
        yield put(updateSproCarrierList(list));
        yield put(updateSproCarrierTotalElements(total));
        tempStatusObj.status = true;
        yield put(updateSproCarrierOperationObj(tempStatusObj));
    } catch (err) {
        tempStatusObj.status = false;
        tempStatusObj.message = err?.response?.data || 'Unable to fetch carrier list';
        yield put(updateSproCarrierOperationObj(tempStatusObj));
    } finally {
        yield put(updateSproCarrierIsLoading(false));
    }
}

function* updateSproCarrierStatusSaga(data) {
    const tempStatusObj = { ...data.operationObj };
    try {
        yield put(updateSproCarrierIsLoading(true));
        const response = yield call(Uchain.sproCarrierManagement, data.payload);
        // API may return a plain object {"RESULT":"..."} or an array [{"RESULT":"..."}]
        const resultObj = Array.isArray(response) ? response[0] : response;
        const resultMsg = resultObj?.RESULT || '';
        const isSuccess = resultMsg === 'Updated Successfully';
        tempStatusObj.status = isSuccess;
        tempStatusObj.message = resultMsg || 'Unable to update carrier status';
        yield put(updateSproCarrierOperationObj(tempStatusObj));
    } catch (err) {
        tempStatusObj.status = false;
        tempStatusObj.message = err?.response?.data || 'Unable to update carrier status';
        yield put(updateSproCarrierOperationObj(tempStatusObj));
    } finally {
        yield put(updateSproCarrierIsLoading(false));
    }
}

function* resetSproCarrierOperationObjSaga() {
    try {
        yield put(updateSproCarrierOperationObj({ type: '', status: '' }));
    } catch {}
}

export function* fetchSproCarrierListWatcher() {
    yield takeLatest(sagaActions.FETCH_SPRO_CARRIER_LIST, fetchSproCarrierListSaga);
}

export function* updateSproCarrierStatusWatcher() {
    yield takeEvery(sagaActions.UPDATE_SPRO_CARRIER_STATUS, updateSproCarrierStatusSaga);
}

export function* resetSproCarrierOperationObjWatcher() {
    yield takeEvery(sagaActions.RESET_SPRO_CARRIER_OPERATION_OBJ, resetSproCarrierOperationObjSaga);
}